import React , { useState }  from "react";
import { Card, ListGroup, Button, Modal  } from "react-bootstrap";
import { Link } from "react-router-dom";
import { Container, Row, Col, Image } from "react-bootstrap";
import { motion } from "framer-motion";
import { FaFacebook, FaTiktok, FaYoutube, FaInstagram, FaArrowLeft, FaArrowRight  } from "react-icons/fa";
import Footer from './footer';
import LatestUpdates from "./latestupdates";
import "./img.css";
const CourseChange = () => {
    return (

        <>
            <Container className="mt-5">
                <Row>
                    {/* Left Section - Image and Title */}


                    <Col md={8} className="d-flex flex-column align-items-center text-center">
                        <Image src="./img/course-change.jpg" alt="Professional Year" fluid />
                        <h2 className="mt-3">Admissions And Course Change</h2>
                    </Col>

                    {/* Right Section - Latest Posts and Social Media */}
                    <Col md={4}>
                        <Card>
                            <Card.Header className="fw-bold">Latest Posts</Card.Header>
                            <ListGroup variant="flush">
                                <ListGroup.Item><Link to="/professional" className="dropdown-item"> <a href="" className="text-decoration-none">Professional Year</a> </Link></ListGroup.Item>
                                <ListGroup.Item><Link to="/coursechange" className="dropdown-item"> <a href="" className="text-decoration-none">Admissions And Course Change </a></Link></ListGroup.Item>
                                <ListGroup.Item><Link to="/skilledID" className="dropdown-item"> <a href="" className="text-decoration-none">   Skilled Independent Visa (Subclass 189)</a></Link></ListGroup.Item>
                                <ListGroup.Item><Link to="/workregionalvisa" className="dropdown-item"> <a href="" className="text-decoration-none">Skilled Work Regional Visa (Subclass 491)</a></Link></ListGroup.Item>
                                <ListGroup.Item><Link to="/nominatedvisa" className="dropdown-item"> <a href="" className="text-decoration-none">Skilled Nominated Visa (Subclass 190)</a></Link></ListGroup.Item>
                                <ListGroup.Item><a href="https://immi.homeaffairs.gov.au/visas/getting-a-visa/visa-listing/skilled-regional-191"
                                    className="dropdown-item text-decoration-none"
                                    style={{ color: "#22327f" }}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    Permanent Residence visa (Subclass 191)
                                  </a>
                                </ListGroup.Item>{/* <ListGroup.Item><Link to="/regionalvisa"className="dropdown-item"><a href="" className="text-decoration-none">Skilled Regional Visa (Subclass 887)</a></Link></ListGroup.Item> */}
                                                               <ListGroup.Item><Link to="/tempactivity"className="dropdown-item"><a href="" className="text-decoration-none">Temporary Activity Visa (Subclass 408)</a></Link></ListGroup.Item>
                                                               </ListGroup>
                        </Card>
                    </Col>
                </Row>
            </Container>
            <SecondSection />
            <LogoGrid />
          
          
            <LatestUpdates/>
            <Footer />
        </>
    );

};





export default CourseChange;

const SecondSection = () => {
    return (
        <>
            <Container className="mt-4">

                {/* YouTube Embed Section */}
                <Row className="mt-3">
                    <Col md={8}>
                        <div className="ratio ratio-16x9">
                            <iframe
                                width="100%"
                                height="400"
                                src="https://www.youtube.com/embed/KV4mo4tRY_I"
                                title="YouTube video"
                                frameBorder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowFullScreen
                            ></iframe>
                        </div><br />
                        <p>Do you want to take admission in any course?</p>
                        <p>Do you want to change the course and want to go to one
                            College or University to other College or University?</p>
                        <p>Do you want to go from degree to diploma course?</p>
                        <p>Do you want to look for course that can increase the prospects of getting Permanent Visa?</p>
                        <p>Do you want to save money by changing university or college?</p>
                        <p>If you have any of above question you have landed on right website. We have been in education industry
                            for last 13 years and have helped thousands of international students choosing the right course and
                            University and college.</p>
                        <p>We can also help you change your career and if you want to do any higher studies we can still help
                            you get in. We have helped students to get enrolled in almost every university of Australia.</p>
                        <p>We have the expertise and associations to help guide you on the best study course to suit your
                            requirement and interest.</p>
                        <p>Here is a list of some pAATners colleges, but we have associations with a lot more universities and colleges.</p>
                    </Col>

                  {/* Right Side: Sidebar Section (Responsive) */}
<Col xs={12} md={3} className="sidebar-container">
    <Card className="p-3 text-center">
        {/* Bajwa Immigration Image */}
        <Image
            src="./img/brand-logo.png"
            alt="Bajwa Immigration Logo"
            fluid
            className="mb-3"
        />

        <h6 className="fw-bold">Subscribe to our YouTube channel</h6>
        <Button variant="danger" className="mb-3">
            <a href="https://www.youtube.com/channel/UCB2YzDKqwiv4IH4A6zoKKWw">SUBSCRIBE</a>
        </Button>

        <h6 className="fw-bold">Book Consultation</h6>
        <Button variant="warning">BOOK CONSULTATION</Button>

        <h6 className="fw-bold mt-3">Like Us on Facebook !!</h6>
        {/* Facebook Embed */}
        <iframe
            src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2FBajwaImmigration&tabs&width=340&height=130&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&appId"
            width="100%"
            height="130"
            style={{ border: "none", overflow: "hidden" }}
            scrolling="no"
            frameBorder="0"
            allowFullScreen
        ></iframe>

        {/* Social Media */}
        <h6 className="fw-bold mt-3">We are also on:</h6>
        <div className="d-flex justify-content-center gap-3">
            <FaInstagram size={30} color="#C13584" />
            <FaTiktok size={30} color="#000" />
            <FaYoutube size={30} color="crimson" />
        </div>
    </Card>
</Col>

                </Row>
                <motion.button
    initial={{ x: "-100vw", opacity: 0 }}
    animate={{ x: 0, opacity: 1 }}
    transition={{ type: "tween", duration: 0.6, ease: "easeOut" }}
    className="btn btn-danger btn-sm position-fixed bottom-0 stAAT-0 m-3"
    style={{ zIndex: 1050 }}
>
    <i className="bi bi-chat-left-text me-1"></i>
    <a 
        href="https://au.bajwaimmigration.com/book-appointment" 
        className="text-white text-decoration-none"
    >
        Consult Now
    </a>
</motion.button>
            </Container>

        </>
    );
};

const logos = [
    { src: "./img/Central Melbourne Institute.png", alt: "Central Melbourne Institute" },
    { src: "./img/Think Education.png", alt: "Think Education" },
    { src: "./img/Victorian Institute of Technology.png", alt: "Victorian Institute of Technology" },
    { src: "./img/Torrens University Australia.gif", alt: "Torrens University Australia" },
    { src: "./img/Della International College.png", alt: "Della International College" },
    { src: "./img/Federation University Australia.png", alt: "Federation University Australia" },
    { src: "./img/Holmes Institute.png", alt: "Holmes Institute" },
    { src: "./img/Nurse Training Australia.png", alt: "Nurse Training Australia" },
    { src: "./img/Lennox.png", alt: "Lennox" },
    { src: "./img/nova-college.png", alt: "Nova College" }
  ];
  
  const LogoGrid = () => {
    const [selectedImage, setSelectedImage] = useState(null);
  
    // Function to open modal with clicked image
    const handleImageClick = (src) => {
      setSelectedImage(src);
    };
  
    // Function to close modal
    const handleClose = () => {
      setSelectedImage(null);
    };
  
    return (
      <Container className="my-4">
        <Row className="justify-content-center">
          {/* Main Content Section - Matches YouTube Section Width */}
          <Col md={8}>
            <Row className="justify-content-center">
              {logos.map((logo, index) => (
                <Col key={index} xs={6} sm={4} md={3} lg={2} className="text-center mb-3">
                  <Image
                    src={logo.src}
                    alt={logo.alt}
                    fluid
                    className="logo-img"
                    onClick={() => handleImageClick(logo.src)}
                    style={{ cursor: "pointer" }} // Makes the image look clickable
                  />
                </Col>
              ))}
            </Row>
          </Col>
        </Row>
  
        {/* Modal for Enlarged Image */}
        <Modal show={selectedImage !== null} onHide={handleClose} centered>
          <Modal.Body className="text-center">
            <Image src={selectedImage} alt="Enlarged Logo" fluid />
          </Modal.Body>
        </Modal>
      </Container>
    );
  };